<template>
  <section v-if="service" class="mb-5">
    <h2 class="display-4 mb-4">Service des Geräts Bearbeiten</h2>
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-12 col-md-8">
          <div class="container">
            <div class="mb-3">
              <label for="title" class="form-label">Titel</label>
              <input type="text" class="form-control" id="title" v-model="service.title" placeholder="Apple" />
            </div>
            <div class="row mb-3">
              <div class="col-12 col-md-6">
                <label for="price" class="form-label">Preis</label>
                <input type="number" class="form-control" id="price" v-model="service.price" placeholder="S" />
              </div>
              <div class="col-12 col-md-6">
                <label for="state" class="form-label">Status</label>
                <select id="state" v-model="data.state" class="form-select" aria-label="Default select example">
                  <option value="0">Nicht verfügbar</option>
                  <option value="1">verfügbar</option>
                </select>
              </div>
            </div>
            <div class="mb-3">
              <label for="description" class="form-label">Beschreibung</label>
              <textarea class="form-control" id="description" v-model="service.description" rows="3"></textarea>
            </div>

            <button type="button" class="btn btn-primary" @click="addOrEditService">Speichern</button>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
    name: "ServiceEdit",

    data() {
        return {
          service: undefined,
          data: {
              servicetype_key: undefined,
              device_key: undefined,
              title: "",
              price: 0,
              description: "",
              state: 1,
          },
        };
    },

    mounted() {
      this.$nextTick(() => {
        this.$store.state.modules.api
        .getServiceByUid(JSON.parse(localStorage.account).token, this.$route.params.uid)
        .then((resp) => {
          if (resp.status == 200) {
            this.service = resp.data.results;
            // this.loadUnits();
            this.$store.state.utils.loaded = true;
          } else {
            this.$router.push({ name: "NotFound" });
          }
        })
        .catch((err) => {
            console.error(err);
        });
      });
    },

    watch: {},

    methods: {
      addOrEditService() {
        this.$store.state.modules.api
        .addOrEditService(this.service)
        .then((resp) => {
          if (resp.status == 200) {
            this.$store.state.utils.setNewNotifications({
              type: "success",
              title: "Service bearbeiten",
              message: "Die Service wurde erfolgreich aktualisiert",
            },
              2500
            );
            this.$router.push({ name: "CPanel" });
          } else {
            this.$store.state.utils.setNewNotifications({
              type: "warning",
              title: "Fehlermeldung",
              message: "Etwas ist schief gelaufen. :(",
            },
              2500
            );
          }
        })
        .catch((err) => {
          console.error(err);
        });
      },
    },
};
</script>
